module.exports = __webpack_public_path__ + "static/8-b807cb151d85f4d77ffa1d46c7d38a0d.jpeg";